export default class VanModuleCreateError extends Error {
  constructor(message) {
    super(message);
    this.name = "VanModuleCreateError";
  }
}
